import { render } from "./BtnFavorite.vue?vue&type=template&id=13f6171b&scoped=true"
import script from "./BtnFavorite.vue?vue&type=script&lang=js"
export * from "./BtnFavorite.vue?vue&type=script&lang=js"

import "./BtnFavorite.vue?vue&type=style&index=0&id=13f6171b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f6171b"]])

export default __exports__